<template lang="html">
    <report-section
        :id="id"
        title="Allocations"
        class="is-hidden-touch"
    >
        <p>
            Water licences<sup>
                <footnote-tooltip
                    :footnote-number="21"
                />
            </sup> and short term use approvals<sup>
                <footnote-tooltip
                    :footnote-number="20"
                />,
                <footnote-tooltip
                    :footnote-number="21"
                />
            </sup> (collectively, ‘allocations’) for surface water and groundwater in British Columbia are managed
            under the Water Sustainability Act<sup>
                <footnote-tooltip
                    :footnote-number="10"
                />
            </sup>. These allocations are authorized by the Ministry of Forests, and the BC Energy Regulator
            (associated with activities regulated under the Oil and Gas Activities Act<sup>
                <footnote-tooltip
                    :footnote-number="11"
                />
            </sup>). Existing allocations, and active water licence applications<sup>
                <footnote-tooltip
                    :footnote-number="22"
                />
            </sup> within the query basin are summarized and listed in the charts and tables below.
        </p>
        <div v-if="reportData.allocations.length !== 0">
            <h4 class="title is-5 total-annual-volume">
                BC Water Sustainability Act - Water Licences -
                {{ licenceCount }} {{ licencePluralization }},
                {{ totalAllocationVolume | numAutoFormat }} m³ Total Annual Volume<sup class="footnote-tooltip">
                    <footnote-tooltip
                        :footnote-number="9"
                    />
                </sup>
            </h4>
            <allocations-table
                :licences="reportData.allocations"
                per-page="8"
            />
        </div>

        <h4
            v-else
            class="title is-4"
        >
            No Allocations for selected watershed.
        </h4>
    </report-section>
</template>

<script>
import sectionMixin from '@foundryspatial/report-section/mixin';

import AllocationsTable from '@/components/AllocationsTable.vue';

export default {
    name: 'AllocationsTableSection',

    components: {
        AllocationsTable,
    },

    mixins: [
        sectionMixin,
    ],

    data: () => ({
        // declared statically so order will always be the same across reports
        allocationTypes: [
            'sw-lic',
            'gw-lic',
            'sw-stu',
            'gw-stu',
            'sw-app',
            'gw-app',
        ],
    }),

    computed: {
        totalAllocationVolume() {
            return this.reportData.annualHydrology.allocs_m3yr.query;
        },

        licenceCount() {
            return this.reportData.overview.lic_count;
        },

        licencePluralization() {
            if (this.reportData.allocations.length === 1) {
                return 'Licence';
            }
            return 'Licences';
        },
    },
};
</script>

<style lang="scss">
.total-annual-volume {
    .footnote-tooltip {
        color: $secondary;
    }
}
</style>
